module.exports = "/images/Rock Climbing.svg?7fefef741ee01b26b561e90460ef93ce";